import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from 'context/AuthContext';
import { SimpleHeader } from 'components/ui/SimpleHeader';
import { setStorageItem } from 'utils/storage';
import logoPremioPrincipal from 'assets/img/2026/logo_premio_page.png';
import logoPremioBB from 'assets/img/2026/logo_premio.png';
import personagemPerfil from 'assets/img/2026/personagem_perfil_BB.png';
import SpaceLogin from 'assets/img/2026/estrelas_fundo.png';
import './style.scss';

export function LoginPublic() {
  const navigate = useNavigate();
  const { loginWithToken, login } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const handleIniciarJornada = () => {
    navigate('/home-public');
  };

  useEffect(() => {
    async function doLogin(username: string, password: string) {
      try {
        try { window.localStorage.removeItem('bb.banca-session'); } catch {}
        await login({ username, password });

        // Aguarda um pouco antes de navegar para garantir que tudo foi salvo
        setTimeout(() => {
          navigate("/home-public");
        }, 150);
      } catch (e) {
        console.error('Login failed:', e);
        setLoading(false);
      }
    }

    async function doLoginWithToken(token: string) {
      try {
        try { window.localStorage.removeItem('bb.banca-session'); } catch {}
        await loginWithToken(token);
        
        // Aguarda um pouco antes de navegar
        setTimeout(() => {
          navigate("/home-public");
        }, 150);
      } catch (e) {
        console.error('Token login failed:', e);
        setLoading(false);
      }
    }

    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const agent = params.get("agent");
    const secret = params.get("secret");
    const tokenItem = params.get("tokenItem");

    if (token) {
      setLoading(true);
      doLoginWithToken(token);
    } else if (agent && secret) {
      setLoading(true);
      doLogin(agent, secret);
    } else if (tokenItem) {
      setLoading(true);
      const decodedToken = atob(tokenItem);
      const tokenParts = decodedToken.split(":");
      const id = tokenParts[0];
      const password = tokenParts[1];

      setStorageItem("readOnly", "true");
      doLogin(id, password);
    }
  }, [loginWithToken, login, navigate]);

  return (
    <div id="login-public-wrapper">
      <div className="relative flex flex-col w-screen h-screen bg-gradient-to-br from-blue-bb via-blue-bb-1 to-blue-bb-5 overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-100" aria-hidden="true">
          <img
            src={SpaceLogin}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>

        <div className="absolute top-0 left-0 right-0 z-50">
          <SimpleHeader title="Prêmio BB" userName="" customLogo={logoPremioBB} />
        </div>

        <main className="flex flex-1 items-center justify-center px-4 md:px-8 lg:px-12 relative pt-20 pb-4">
          <div className="flex flex-col items-center justify-center max-w-5xl z-10 w-full login-content">
            <div tabIndex={0} className="text-center mb-3 space-y-0.5">
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-pink-bb leading-tight">
                <span className="block">A grande jornada com ideias</span>
                <span className="block">transformadoras e inspiradoras começou.</span>
              </h1>
              <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-blue-bb-6 leading-tight mt-1">
                Foi dada a largada ao <span className="text-yellow-bb">Prêmio BB!</span>
              </p>
            </div>

            <div className="flex justify-center mb-4">
              <button
                onClick={handleIniciarJornada}
                className="btn-iniciar-jornada"
                disabled={loading}
                aria-busy={loading ? "true" : "false"}
              >
                {loading ? 'CARREGANDO...' : 'INICIAR JORNADA!'}
              </button>
            </div>

            <div tabIndex={0} aria-label='Logo do Prêmio e Personagem puxando a manivela' className="relative flex items-end justify-center images-container">
              <div className="relative z-20">
                <img
                  src={personagemPerfil}
                  alt=""
                  aria-hidden="true"
                  className="h-40 md:h-48 lg:h-60 w-auto object-contain"
                />
              </div>

              <div className="relative z-10 -ml-6 md:-ml-8 lg:-ml-10">
                <img
                  src={logoPremioPrincipal}
                  alt="Logo Prêmio BB"
                  className="h-56 md:h-64 lg:h-80 w-auto object-contain"
                />
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
